"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const kor_1 = require("./kor");
function fieldToString(field, _default) {
    if (typeof field == "string")
        return field;
    return _default;
}
exports.fieldToString = fieldToString;
function fieldToPoint(field, _default) {
    if (field instanceof Array
        && field.length === 2
        && typeof field[0] === "number" && _.isFinite(field[0])
        && typeof field[1] === "number" && _.isFinite(field[1])) {
        return new kor_1.Point(field[0], field[1]);
    }
    return _default;
}
exports.fieldToPoint = fieldToPoint;
function fieldToSize(field, _default) {
    const point = fieldToPoint(field, null);
    if (point) {
        return new kor_1.Size(point.x, point.y);
    }
    return _default;
}
exports.fieldToSize = fieldToSize;
function fieldToNumber(field, _default) {
    if (typeof field == "number" && _.isFinite(field))
        return field;
    return _default;
}
exports.fieldToNumber = fieldToNumber;
